const PREFIX = `conversations_client.support_conversations_client`;

export const METRIC = {
  transition_to_chat_success: `${PREFIX}.transition_to_chat.success`,
  transition_to_chat_error: `${PREFIX}.transition_to_chat.error`,
  transition_to_rac_success: `${PREFIX}.transition_to_rac.success`,
  transition_to_rac_error: `${PREFIX}.transition_to_rac.error`,
  transition_to_email_success: `${PREFIX}.transition_to_email.success`,
  transition_to_email_error: `${PREFIX}.transition_to_email.error`,
  abandon_chat_success: `${PREFIX}.abandon_chat.success`,
  abandon_chat_error: `${PREFIX}.abandon_chat.error`,
  conversation_load_duration: `${PREFIX}.conversation_load.duration`,
};
